<template>
  <section class="employee-benefit">
    <div class="page-header" v-if="vestingSchedule">
      <div></div>
      <div class="header-actions">
        <router-link
          :to="{
            name: 'EsopDetails',
            query: { asset: esopToken.asset },
          }"
          class="primary-action"
        >
          <Btn title="Configure Employee Benefit" />
        </router-link>
      </div>
    </div>
    <div v-if="vestingSchedule">
      <EsopOverviewCard class="overview-card" />
      <div class="content-section">
        <div class="table-toolbar">
          <div class="toolbar-tabs">
            <TableHeader
              :options="options"
              :tab="option"
              label="options"
              @emitOption="emitOption"
            />
          </div>
          <div class="toolbar-actions">
            <button
              class="secondary-action"
              @click="showTradeModal = !showTradeModal"
            >
              Trade
            </button>

            <button
              class="secondary-action"
              @click="$router.push({ name: 'InviteEmployee' })"
            >
              Invite Employee
            </button>
            <button
              class="outline-action"
              @click="$router.push({ name: currentOption })"
            >
              View all {{ option === "Order Book" ? "Orders" : option }}
            </button>
          </div>
        </div>
        <div class="table-content">
          <div v-if="table === 'employeeTable'">
            <EmployeesTable
              :tableRows="tableRows"
              :tableHeaders="tableHeaders"
              :columnNumber="2"
              :totalPage="1"
              :currentPage="1"
              :columnWidth="150"
              :showPagination="false"
            />
          </div>
          <StockTradeTable v-if="table === 'stockTradeTable'" />
          <EsopTransactionsTable
            v-if="table === 'transaction'"
            :token="esopToken"
          />
          <EmployeesEmptyState v-if="table === ''" />
        </div>
      </div>
    </div>
    <TradeModal
      v-if="showTradeModal"
      :title="tradeModalTitle"
      :form="tradeForm"
      :bgChange="bgChange"
      :showBackButton="showBackButton"
      @close="showTradeModal = !showTradeModal"
      @goBack="goBack"
      @mounted="tradeForm = 'esopAmountForm'"
    >
      <template v-slot:content>
        <EsopAmountForm
          v-if="tradeForm === 'esopAmountForm'"
          :currentEsop="esopToken"
          @tradeType="setTradeType"
          @storeData="switchTradeForm"
        />
        <EsopConfirmationForm
          v-if="tradeForm === 'esopConfirmationForm'"
          :tradeType="tradeType"
          :currentEsop="esopToken"
          @close="showTradeModal = !showTradeModal"
        />
      </template>
    </TradeModal>
    <StockEmptyState
      v-if="!loading && !vestingSchedule"
      @show-modal="showInfoModal"
    />
    <Teleport to="#teleport-modal">
      <SmallModal v-if="showModal" @close="showModal = !showModal">
        <template v-slot:content>
          <div class="tw-flex tw-justify-center tw-mb-6">
            <img
              src="@/assets/img/orange-info.svg"
              alt="info"
              class="tw-cursor-pointer"
            />
          </div>
          <div class="tw-mb-10">
            <h3 class="tw-text-lg tw-font-semibold tw-text-center tw-mb-7">
              To set up Employee Benefits, you have to create an asset
            </h3>
            <p class="tw-text-sm tw-text-center">
              This asset is where you will be handing out employee shares from.
            </p>
          </div>
          <Btn
            v-if="!orgDetails.asset"
            title="Continue to Create Asset"
            @click="
              $router.push({
                name: 'CreateAsset',
                params: { type: 'employee-benefits' },
              })
            "
          />
          <div class="tw-mt-3 5">
            <Btn title="Cancel" @click="showModal = !showModal" />
          </div>
        </template>
      </SmallModal>
    </Teleport>
  </section>
</template>

<script>
  import EmployeesEmptyState from "@/components/employeesBenefit/EmployeesEmptyState";
import EsopOverviewCard from "@/components/employeesBenefit/EsopOverviewCard";
import StockEmptyState from "@/components/employeesBenefit/StockEmptyState";
import EsopAmountForm from "@/components/employeesBenefit/trade/EsopAmountForm.vue";
import EsopConfirmationForm from "@/components/employeesBenefit/trade/EsopConfirmationForm.vue";
import Btn from "@/components/general/BtnComponent";
import SmallModal from "@/components/general/SmallModal";
import TradeModal from "@/components/general/sidemodal/SideModal.vue";
import TableHeader from "@/components/tables/TableHeader";
import EmployeesTable from "@/components/tables/esop/EmployeesTable";
import EsopTransactionsTable from "@/components/tables/esop/EsopTransactionsTable";
import StockTradeTable from "@/components/tables/esop/StockTradeTable";
import { getItem } from "@/utils/storage.js";
import { mapActions, mapGetters, mapState } from "vuex";

  import {
  convertToLocale,
  formatAmountToDollar,
  formatISODate,
  truncate,
} from "@/utils/helpers.js";
  export default {
    name: "EmployeeBenefitIndex",
    components: {
      StockEmptyState,
      EsopOverviewCard,
      TableHeader,
      EmployeesEmptyState,
      EmployeesTable,
      StockTradeTable,
      EsopTransactionsTable,
      EsopAmountForm,
      EsopConfirmationForm,
      SmallModal,
      TradeModal,
      Btn,
    },
    data() {
      return {
        loading: false,
        showModal: false,
        showTradeModal: false,
        showBackButton: false,
        bgChange: true,
        tableHeaders: [
          "",
          "Employee name",
          "Email address",
          "Start Date",
          "Allocated shares",
          "Shares exercised",
          "Contract status",
          "misc",
        ],
        inviteType: "ESOP_EMPLOYEE",
        tradeModalTitle: "Buy ESOP",
        tradeForm: "esopAmountForm",
        tradeType: "",
        assetId: "",
        tableRows: [],
        currentOption: "",
        option: "",
        options: ["Employees", "Order Book", "Transactions"],
        table: "",
        overviewData: null,
      };
    },
    computed: {
      ...mapGetters("Esop", [
        "esoOverview",
        "vestingSchedule",
        "employeeInvite",
        // "transferRequests",
        "esopToken",
      ]),
      ...mapState({
        orgDetails: (state) => state.organisationModule.organisationDetails,
      }),
    },
    watch: {
      employeeInvite: "updateTableRow",
      inviteType: "tabType",
    },
    created() {
      this.assetId = getItem("org_details").asset;
      this.fetchVestingSchedule();
      this.updateTableRow();
    },
    methods: {
      ...mapActions("Esop", [
        "getEsoOverviewData",
        "getVestingSchedule",
        "getEmployeeInvites",
        // "getTransferRequests",
        "getEsopToken",
      ]),
      convertToLocale,
      formatAmountToDollar,
      tabType() {
        const inviteType = this.inviteType;
        switch (inviteType) {
          case "TRF_REQUEST":
            // this.fetchTransferRequests();
            break;
          default:
            this.fetchVestingSchedule();
        }
      },
      // async fetchTransferRequests() {
      //   const query = {
      //     page: 1,
      //     limit: 10,
      //   };
      //   try {
      //     await this.getTransferRequests(query);
      //   } catch (error) {
      //     return error;
      //   }
      // },
      showInfoModal() {
        if (this.assetId) {
          this.$router.push({
            name: "CreateAssetInfo",
            params: { type: "employee-benefits" },
            query: { asset: `${this.assetId}` },
          });
        } else {
          this.showModal = !this.showModal;
        }
      },

      async fetchVestingSchedule() {
        this.loading = true;
        try {
          let query = {
            page: 1,
            limit: 10,
          };
          if (this.inviteType) {
            query = {
              ...query,
              // employee_type: this.inviteType,
            };
          }
          await Promise.all([
            this.getEsopToken(),
            this.getEsoOverviewData({
              // employee_type: "ESOP_EMPLOYEE",
            }),
            this.getVestingSchedule(),
            this.getEmployeeInvites(query),
          ]);
          this.loading = false;
        } catch (error) {
          return error;
        }
      },

      goBack(form) {
        switch (form) {
          case "esopConfirmationForm":
            this.tradeForm = "esopAmountForm";
            this.tradeModalTitle = `Buy ESOP`;
            this.showBackButton = false;
            break;
          default:
            break;
        }
      },

      setTradeType(type) {
        this.tradeType = type;
      },

      switchTradeForm(form) {
        switch (form) {
          case "esopAmountForm":
            this.tradeForm = "esopConfirmationForm";
            this.tradeModalTitle = "Confirm Transaction";
            this.showBackButton = true;
            break;

          default:
            break;
        }
      },

      emitOption(option) {
        // this.tableRows = [];
        switch (option) {
          case "Employees":
            this.currentOption = "Employees";
            this.option = "Employees";
            this.table = "employeeTable";

            break;
          case "Order Book":
            this.currentOption = "StockTrade";
            this.option = "Order Book";
            this.table = "stockTradeTable";

            break;
          case "Transactions":
            this.currentOption = "EsopTransactions";
            this.option = "Transactions";
            this.table = "transaction";

            break;

          default:
            break;
        }
      },

      updateTableRow() {
        this.overviewData = this.esoOverview ? this.esoOverview : null;
        this.tableRows = this.employeeInvite?.map((employee) => {
          const name = truncate(`${employee.invitation.name}`, 20);
          const email = truncate(employee.invitation.email, 18);
          const date = `${formatISODate(
            employee.start_date
          )}`;
          const allocatedShares = convertToLocale(employee.allocated_shares);
          const sharesHeld =
            employee.status === "Accepted" && employee.employee
              ? convertToLocale(employee.employee?.exercised_amount)
              : "---";
          let status = null;
          switch (employee.status) {
            case "Accepted":
              status = "Signed";
              break;
            default:
              status = employee.status;
              break;
          }
          let type = employee.employee_type;
          switch (type) {
            case "ESOP_EMPLOYEE":
              type = "ESOP";
              break;

            case "RSU_EMPLOYEE":
              type = "RSU";
              break;

            default:
              break;
          }
          // vesting calculation:

          // X = ratio of vested esop
          let vestedEsop = null;
          // Total vesting duration in days = D
          const vestingDuration = employee.vesting_duration * 365;
          // Vesting frequency in days = C
          const vestingFrequency = employee.vesting_frequency;
          // Number of vesting cycles elapsed = A
          // A = (currentData - startDate) in days / C
          // const daysElapsed = 1825;
          const daysElapsed = Math.ceil(
            (new Date() - new Date(employee.start_date)) /
              (1000 * 3600 * 24)
          );
          const vestingElapsed = daysElapsed / vestingFrequency;
          // Total number of vesting cycles in duration = B
          // B = D / C
          const vestingCycles = vestingDuration / vestingFrequency;

          // X = A/B
          vestedEsop = vestingElapsed / vestingCycles;

          return {
            type,
            name,
            email,
            date,
            allocatedShares,
            sharesHeld,
            status,
            misc: `misc/${employee._id}`,
          };
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .employee-benefit {
    @include fadeIn;
    padding: 24px 20px 32px;
  }

  .page-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 24px;
  }

  .header-actions {
    display: flex;
    align-items: center;
  }

  .primary-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: #4D84FF;
    color: white;
    padding: 4px;
    transition: all 0.2s ease;

    &:hover {
      background: #3B6FE8;
    }
  }

  .overview-card {
    margin-top: 24px;
  }

  .content-section {
    margin-top: 32px;
  }

  .table-toolbar {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);

    @media screen and (min-width: 1024px) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 16px 20px;
    }
  }

  .toolbar-actions {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;

    @media screen and (min-width: 640px) {
      grid-template-columns: repeat(3, auto);
      justify-content: end;
    }
  }

  .secondary-action,
  .outline-action {
    height: 40px;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    padding: 0 16px;
    border: 1px solid transparent;
    transition: all 0.2s ease;
    cursor: pointer;
    white-space: nowrap;
  }

  .secondary-action {
    background: #0F172A;
    color: #FFFFFF;

    &:hover {
      background: #1E293B;
    }
  }

  .outline-action {
    background: #F8FAFC;
    color: #0F172A;
    border-color: #E2E8F0;

    &:hover {
      border-color: #4D84FF;
      color: #4D84FF;
    }
  }

  .table-content {
    margin-top: 24px;
  }
</style>
